import React from 'react';

/**
 * The KPI tiles some list pages carry between the masthead and the toolbar
 * (Tillgångar, Utlägg, Kundfakturor, Bankhändelser).
 *
 * Optional by design — most list pages don't need one, and a strip of tiles
 * that restate the row count is noise. Use it when the numbers answer a
 * question the list itself doesn't.
 */
export const StatCard = ({ icon: Icon, label, value, sub, tone = 'primary' }) => (
    <div className="ll-stat">
        {Icon && (
            <span className={`ll-stat__icon ll-stat__icon--${tone}`}>
                <Icon size={20} strokeWidth={1.75} />
            </span>
        )}
        <div className="ll-stat__value">{value}</div>
        <div className="ll-stat__label">{label}</div>
        {sub && <div className="ll-stat__sub">{sub}</div>}
    </div>
);

export const StatStrip = ({ children, className = '' }) => (
    <div className={`ll-stats ${className}`.trim()}>{children}</div>
);

export default StatStrip;
